namespace GeniuzPOS.Administration {
    export namespace PsFuncKbMapShiftCodeService {
        export const baseUrl = 'Administration/PsFuncKbMapShiftCode';

        export declare function Create(request: Serenity.SaveRequest<PsFuncKbMapShiftCodeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsFuncKbMapShiftCodeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsFuncKbMapShiftCodeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsFuncKbMapShiftCodeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/PsFuncKbMapShiftCode/Create",
            Update = "Administration/PsFuncKbMapShiftCode/Update",
            Delete = "Administration/PsFuncKbMapShiftCode/Delete",
            Retrieve = "Administration/PsFuncKbMapShiftCode/Retrieve",
            List = "Administration/PsFuncKbMapShiftCode/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsFuncKbMapShiftCodeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
